import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Product } from '~domain/product/Product';
import { buyerInfoSelector } from '~redux/buyer/selectors';
import { selectDirectContactOwners } from '~redux/contact';
import { selectProjectId } from '~redux/project';
import MagProductDetail from '~view/widgets/MagProductDetail';
import ProductPostDetails from '~view/widgets/ProductPostDetails';

type ProductPostDetailsProps = {
  product: Product;
};

const ProductDetails: React.FC<ProductPostDetailsProps> = ({ product }) => {
  const buyerInfo = useSelector(buyerInfoSelector);
  const directOwners = useSelector(selectDirectContactOwners);
  const projectId = useSelector(selectProjectId);
  if (
    product &&
    (!product.isPublished(
      buyerInfo?.contacts?.items
        .map(
          (item) =>
            item.contactListConnections?.items.map(
              (list) => list.contact_list_id!
            ) ?? []
        )
        .flat() ?? []
    ) ||
      (product.brand.sell_only_direct &&
        !directOwners?.includes(product.product_owner)))
  ) {
    return (
      <div className="p-6 d-flex justify-content-center">
        <strong>この商品は現在非公開です。</strong>
      </div>
    );
  }
  if (projectId === 'mag') {
    return <MagProductDetail product={product} />;
  }
  return <ProductPostDetails product={product} />;
};

export default ProductDetails;
